import { Component, Prop, Vue } from "vue-property-decorator";
import * as tsx from "vue-tsx-support";

import { BFormGroup, BFormTags } from "@/lib/typed-bootstrap";

@Component
export default class FormTags extends Vue {
  _tsx!: tsx.DeclareProps<{
    value?: FormTags["value"];
    label?: FormTags["label"];
    labelAmendment?: FormTags["labelAmendment"];
    placeholderText: FormTags["placeholderText"];
    upperCaseLabel?: FormTags["upperCaseLabel"];
    shouldValidate?: FormTags["shouldValidate"];
  }> &
    tsx.DeclareOnEvents<{
      onInput: (value: (string | number | boolean)[]) => void;
    }>;

  @Prop() value!: (string | number | boolean)[];
  @Prop({ required: false }) readonly label?: string;
  @Prop({ required: false }) readonly labelAmendment?: string;
  @Prop({ required: true }) readonly placeholderText!: string;
  @Prop({ default: true }) readonly upperCaseLabel!: boolean;
  @Prop({ default: false }) readonly shouldValidate!: boolean;

  get internalValue(): (string | number | boolean)[] {
    return this.value ?? [];
  }

  set internalValue(value: (string | number | boolean)[]) {
    this.$emit("input", value);
  }

  get isValidValue(): boolean {
    return this.internalValue.length > 0;
  }

  onTagState(valid: string[], invalid: string[], duplicate: string[]) {
    console.log(valid, invalid, duplicate);
    return true;
  }

  render() {
    return (
      <BFormGroup
        class={["default__form-group", { uppercase: this.upperCaseLabel }]}
      >
        {this.label && (
          <label>
            {this.labelAmendment && (
              <span class="form-group__label-amendment">
                {this.labelAmendment}
              </span>
            )}
            {this.label}
          </label>
        )}

        <BFormTags
          value={this.internalValue}
          onInput={(val: any) => (this.internalValue = val)}
          inputId={`tags-${this.label || "default"}`}
          class="form-tags__input"
          separator=" ,"
          tagPills
          state={this.shouldValidate && !this.isValidValue ? false : null}
          placeholder={this.placeholderText}
        />
      </BFormGroup>
    );
  }
}
